import React from 'react'

const SvgCheckedIcon = props => (
	<svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect x='3' y='2.5' width='19' height='19' rx='9.5' fill='#009EDB' stroke='#009EDB' strokeWidth='2' />
		<path
			d='M10.5907 14.7343L7.88815 12.0317L6.9873 12.9326L10.5907 16.536L18.3123 8.81442L17.4114 7.91357L10.5907 14.7343Z'
			fill='white'
		/>
	</svg>
)

export default SvgCheckedIcon
